import request from '@/utils/request'
import _ from 'lodash'

const prefix = '/django_rest/company'

export default {
  getCustomJobDetailPageInfo (params) {
    return request.get(`${prefix}/custom-page/job-detail/`, { params })
  },
  getCustomJobListPageInfo (params) {
    return request.get(`${prefix}/custom-page/job-list/`, { params })
  },
  searchCompanyInfo (params) {
    return request.get(`${prefix}/info/`, { params })
  },
  getCompanyBaseInfo (id, params) {
    return request.get(`${prefix}/info/${id}/`, { params })
  },
  getCompanyChildrenTree (params) {
    return request.get(`${prefix}/child/tree/`, { params })
  },
  // 后端按当前账号返回员工管理和公司推荐榜单可访问的公司树列表。
  getHRAccessibleCompanyTree () {
    return request.get(`${prefix}/hr-accessible/tree/`)
  },
  getCompanyPolicyInfo (companyId) {
    return request.get(`${prefix}/${companyId}/policy/`)
  },
  getJobPoster (params) {
    return request.get('/django_rest/job_poster/', { params })
  },
  updateJobPoster (params) {
    return request.put('/django_rest/job_poster/', params)
  },
  getJobPosterTypeList (companyId) {
    return request.get(`/django_rest/job_poster_type/list/?company_id=${companyId}`)
  },
  updateJobPosterStatus (params) {
    return request.put('/django_rest/job_poster_type/status/', params)
  },
  getCustomRewardsRuleInfo (companyId) {
    return request.get(`${prefix}/${companyId}/custom/rewards-rule/`)
  },
  getCompanyJobCreatorList (companyId) {
    return request.get(`/can-used-job-creator/${companyId}/`)
  },
  getTeamMemberList (params) {
    return request.get(`/django_rest/company/${params.companyId}/hr`, { params })
  },
  getCompanyHrList (params) {
    return request.get(`/django_rest/company/${params.companyId}/hr/accounts/`, { params })
  },
  getCompanyJobLocationList (params) {
    return request.get(`${prefix}/job-location/`, { params })
  },
  createCompanyJobLocation (data) {
    return request.post(`${prefix}/job-location/`, data)
  },
  uploadCompanyJobLocation (data) {
    const formData = new FormData()
    _.forEach(data, (value, key) => {
      if (value !== null && value !== undefined) {
        formData.append(key, value)
      }
    })
    return request.post(`${prefix}/job-location/upload/`, formData)
  },
  updateCompanyJobLocation (jobLocationId, data) {
    return request.put(`${prefix}/job-location/${jobLocationId}`, data)
  },
  getCompanyJobPostingChannelList (params) {
    return request.get('/django_rest/get-job-posting-channels/', { params })
  },
  getCompanyStoreFrontList (params) {
    return request.get('/django_rest/store-front/', { params })
  },
  getCompanyGroupedJobList (params) {
    return request.get(`${prefix}/grouped-job/`, { params })
  },
  getCompanyJobBoardPointDashboardList (params) {
    return request.get('/django_rest/job-board-point-dashboard/', { params })
  },
  getClientJobBoardPointDashboardList (params) {
    return request.get('/django_rest/client/job-board-point-dashboard/', { params })
  },
  getCompanyJobBoardPointDashboardHistory (params) {
    return request.get('/django_rest/job-board-point-dashboard/history/', { params })
  },
  transferJobPostingPoints (params) {
    return request.put('/django_rest/job-board-point-dashboard/', params)
  },
  rechargeJobPostingPoints (params) {
    return request.post('/django_rest/job-board-point-dashboard/', params)
  },
  changeJobPostingMaxCount (params) {
    return request.put('/django_rest/job-board-point-dashboard/max-count/', params)
  },
  getCompanyJobList (params) {
    return request.get('/django_rest/company/job/', { params })
  },
  setJobStatus (params) {
    return request.put('/django_rest/company/job/', params)
  },
  getCompanyJobPostingTaskHistory (params) {
    return request.get('/django_rest/job-posting-task/history/', { params })
  },
  createCompanyJobPostingTask (params) {
    return request.post('/django_rest/job-posting-task/', params)
  },
  setHotJob (params) {
    return request.post('/django_rest/company/hot_job/', params)
  },
  refreshJob (params) {
    return request.post('/django_rest/company/refresh_job/', params)
  },
  createCompanyAutomationSettings (params) {
    return request.post('/django_rest/company/automation-settings/', params)
  },
  getCompanyAutomationSettings (companyId) {
    return request.get(`/django_rest/company/automation-settings/${companyId}/`)
  },
  getJobListFilterList (params) {
    return request.get('/django_rest/job_list_custom_filter/', { params })
  },
  updateJobListFilterList (params) {
    return request.post('/django_rest/job_list_custom_filter/', params)
  },
  getCustomLandingPageInfo (pageNum, params) {
    return request.get(`/django_rest/custom-landing-page/${pageNum}/`, { params })
  },
  updateCustomLandingPageInfo (pageNum, data) {
    return request.post(`/django_rest/custom-landing-page/${pageNum}/`, data)
  },
  getCompanyLocation (params) {
    return request.get('/company-locations/', { params })
  },
  getCvOwnerList (params) {
    return request.get(`${prefix}/cv-owner/`, { params })
  },
  getJobFilterItemBinding (filterId, params) {
    return request.get(`/django_rest/custom_job_filter/${filterId}`, { params })
  },
  getJobFilterList (params) {
    return request.get('/django_rest/custom_job_filter/', { params })
  },
  updateJobFilter (filterId, data) {
    return request.put(`/django_rest/custom_job_filter/${filterId}`, data)
  },
  saveJobFilter (data) {
    return request.post('/django_rest/custom_job_filter/', data)
  },
  moveJobFilter (data) {
    return request.post('/django_rest/custom_job_filter/order/', data)
  },
  updateJobFilterItemBinding (filterId, data) {
    return request.post(`/django_rest/job_custom_filter_value_binding/${filterId}`, data)
  },
  // 求职者端 公司主页 查询公司配置的自定义主页数据，同时返回主页和信息页数据
  getCompanyBrandingPageInfo (params) {
    return request.get(`${prefix}/custom-page/company-branding/`, { params })
  },
  // 求职者端 职位列表页 查询公司配置的自定义筛选器（实际使用的是自定义字段）（当前 2024-03-28， 只有 PC 端在使用这个API）
  getCompanyCustomJobFilterList (companyId, params) {
    return request.get(`${prefix}/${companyId}/custom-job-filter/`, { params })
  },
  getCompanyTheme (companyId, params) {
    return request.get(`${prefix}/theme/${companyId}/`, { params })
  },
  getDomainCompany (params) {
    return request.get('/django_rest/domain/company/', { params })
  },
  registerCompany (params) {
    return request.post(`${prefix}/register/`, params)
  }
}
